module.exports = __webpack_public_path__ + "static/filmstudies-20d7de625d19a89fd616bd7b236a1a56.png";